import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";


export const menuItems = [
  {
    group: "APP",
    label: "Dashboard",
    path: "/dashboard",
    icon: "bi-house",
  },
  {
    group: "APP",
    label: "Users",
    path: "/Users",
    icon: "bi-people",
  },
  {
    group: "APP",
    label: "Posts",
    path: "/Posts",
    icon: "bi-layers",
  },
  {
    group: "APP",
    label: "Hashtags",
    path: "/Hashtags",
    icon: "bi-hash",
  },
  {
    group: "APP",
    label: "Gifts",
    path: "/Gifts",
    icon: "bi-gift",
  },
  {
    group: "APP",
    label: "Withdrawals",
    path: "/Withdrawal",
    icon: "bi-wallet-fill",
  },
  {
    group: "APP",
    label: "Coin Packages",
    path: "/coinpackages",
    icon: "bi-box-seam",
  },
  // {
  //   group: "APP",
  //   label: "Restrictions",
  //   path: "/restrictions",
  //   icon: "bi-shield-lock",
  // },
  {
    group: "APP",
    label: "Reports",
    path: "/Reports",
    icon: "bi-exclamation-triangle",
  },
  // {
  //   group: "APP",
  //   label: "Notifications",
  //   path: "/notifications",
  //   icon: "bi-bell",
  // },
  {
    group: "APP",
    label: "Dummy Lives",
    path: "/lives",
    icon: "bi-person-badge-fill",
  },

  {
    group: "APP",
    label: "Delete Requests",
    path: "/delete-requests",
    icon: "bi bi-archive",
  },

  // {
  //   group: "SETTINGS",
  //   label: "Settings",
  //   path: "/ReportReasons",
  //   icon: "bi-gear-fill",
  // },
];

// export const menuItems = [
//   {
//     label: "Dashboard",
//     path: "/dashboard",
//     icon: "bi bi-house",
//   },
//   {
//     label: "Users",
//     path: "/Users",
//     icon: "bi bi-people",
//   },
//   {
//     label: "Posts",
//     path: "/Posts",
//     icon: "bi bi-layers",
//   },
//   {
//     label: "Hashtags",
//     path: "/Hashtags",
//     icon: "bi bi-hash",
//   },
//   {
//     label: "Gifts",
//     path: "/Gifts",
//     icon: "bi bi-gift",
//   },
//   {
//     label: "Withdrawals",
//     path: "/Withdrawal",
//     icon: "bi bi-wallet-fill",
//   },
//   {
//     label: "Coin Packages",
//     path: "/coinpackages",
//     icon: "bi bi-box-seam",
//   },
//   {
//     label: "Restrictions",
//     path: "/restrictions",
//     icon: "bi bi-shield-lock",
//   },
//   {
//     label: "Reports",
//     path: "/Reports",
//     icon: "bi bi-exclamation-triangle",
//   },
//   {
//     label: "Notifications",
//     path: "/notifications",
//     icon: "bi bi-bell",
//   },
//   {
//     label: "Dummy Lives",
//     path: "/lives",
//     icon: "bi bi-person-badge-fill",
//   },
// ];